import {WatchListState, watchListReducer} from '../reducers/watchlist.reducer';
import {ActionReducerMap} from '@ngrx/store';
import {ShoppingCartState, ShoppingCartReducer} from '../reducers/shoppingcart.reducer';
import {digitalWalletReducer, DigitalWalletState} from './digital-wallet.reducer';

export interface AppState {
  watchListState: WatchListState;
  shoppingCartState: ShoppingCartState;
  digitalWalletState: DigitalWalletState;
}

export const reducers: ActionReducerMap<AppState> = {
  watchListState: watchListReducer,
  shoppingCartState: ShoppingCartReducer,
  digitalWalletState: digitalWalletReducer,
};

